// removes the readonly properties from an object
// this is useful for relay types which are readonly

import type { MimeTypeEnum } from '@/graphql/types';

export * from './content';
export * from './react';

export type Implements<T, R extends T> = R;

export type Modify<T, R> = Omit<T, keyof R> & R;

export type SelectOptionType = {
  label: string;
  value: string;
} | null;

export type GraphqlQuery = {
  query: string;
  variables?: { [key: string]: unknown };
};

type ErrorsResponse = {
  message: string;
  extensions: { [key: string]: string };
  locations: Array<{
    line: number;
    column: number;
  }>;
};

export type GraphqlResponse<T> = {
  data?: T;
  errors?: ErrorsResponse[];
};

export enum ZnglyMimeTypes {
  // ZnglyEmbed = 'Zngly_Embed',
  ZnglyImage = 'ZNGLY_IMAGE',
  ZnglyWildCard = 'ZNGLY_WILDCARD',
}

export type MimeTypeEnumExtended = MimeTypeEnum | ZnglyMimeTypes;
